namespace nscs.screen.stories {

    export class AnimationStory_6_1 extends Phaser.GameObjects.Container {

        frame = {name:'AnimationStory_6_1'};

        _bubblex_mc:Phaser.GameObjects.Image;
        _mouthPiece_mc:Phaser.GameObjects.Image;
        _tf:Phaser.GameObjects.Text;
        _bg:Phaser.GameObjects.Image;
        _ground:Phaser.GameObjects.Image;
        _ground1:Phaser.GameObjects.Image;
        _nuget:Phaser.GameObjects.Sprite;
        _chick:Phaser.GameObjects.Sprite;
        _pam:Phaser.GameObjects.Sprite;
        
        constructor(scene:Phaser.Scene) {
            super(scene);
            
            this._bg = this.scene.add.image(-100, -100, 'bg-atlas', 'bg5' + '0000');
            this._bg.setOrigin(0, 0);
            
            this._ground = this.scene.add.image(0, 320, 'stories', 'ground3' + '0000');
            this._ground.setOrigin(0, 1);
            this._ground1 = this.scene.add.image(this._ground.width, 320, 'stories', 'ground3' + '0000');
            this._ground1.setOrigin(0, 1);
            
            
            this._nuget = this.scene.add.sprite(90 - 200, 300, 'stories', '_nuget' + '0000');
            this._nuget.setOrigin(0.5, 1);
            
            this._chick = this.scene.add.sprite(135 - 200, 302, 'stories', '_chick' + '0000');
            this._chick.setOrigin(0.5, 1);
            
            this._pam = this.scene.add.sprite(385 + 200, 297, 'stories', '_pam' + '0000');
            this._pam.setOrigin(0.5, 1);
            
            this.add([this._bg, this._ground, this._ground1, this._chick, this._nuget, this._pam]);

            this.scene.tweens.add({
                targets: this._bg,
                duration: 2000,
                x: -200,
                ease: Phaser.Math.Easing.Cubic.Out
            });
            this.scene.tweens.add({
                targets: this._ground,
                duration: 2000,
                x: this._ground.x - 200,
                ease: Phaser.Math.Easing.Cubic.Out
            });
            this.scene.tweens.add({
                targets: this._ground1,
                duration: 2000,
                x: this._ground1.x - 200,
                ease: Phaser.Math.Easing.Cubic.Out
            });
            this.scene.tweens.add({
                targets: this._pam,
                duration: 2000,
                x: this._pam.x - 200,
                ease: Phaser.Math.Easing.Cubic.Out
            });
            this.scene.tweens.add({
                targets: this._nuget,
                duration: 2000,
                x: this._nuget.x + 200,
                ease: Phaser.Math.Easing.Cubic.Out
            });
            this.scene.tweens.add({
                targets: this._chick,
                duration: 2000,
                x: this._chick.x + 200,
                ease: Phaser.Math.Easing.Cubic.Out
            });

            let anim:string = nscs.gameplay.Factory.createAnimName('_nuget', 'walk');
            if (!this.scene.anims.exists(anim)) {
                this.scene.anims.create({
                    key: anim,
                    frames: this.scene.anims.generateFrameNames(this._nuget.texture.key, {
                        start: 0, end: 30, zeroPad: 4,
                        prefix: '_nuget', suffix: ''
                    }),
                    repeat: 2,
                    frameRate: 60
                });
            }
            this._nuget.play(anim);
            let _anim = nscs.gameplay.Factory.createAnimName('_chick', 'walk');
            if (!this.scene.anims.exists(_anim)) {
                this.scene.anims.create({
                    key: _anim,
                    frames: this.scene.anims.generateFrameNames(this._chick.texture.key, {
                        start: 0, end: 30, zeroPad: 4,
                        prefix: '_chick', suffix: ''
                    }),
                    repeat: 2,
                    frameRate: 60
                });
            }
            util.Functions.delayedCall(150, ()=>{
                this._chick.play(_anim);
            });

            
            util.Functions.delayedCall(2000, ()=>{
                this.showSpeechDialog("activist19");
                util.Functions.delayedCall(13000, ()=>{
                    this.showSpeechDialog("activist20");
                    util.Functions.delayedCall(5000, ()=>{
                        util.Functions.delayedCall(150, ()=>{
                            this._chick.play(_anim);
                        });                        
                        this._nuget.play(anim);

                        this.showSecondPart();
                    });
                });
            });
        }

        private createGraphicsRect(): Phaser.GameObjects.Graphics {
            let r = new Phaser.GameObjects.Graphics(this.scene);
            r.setPosition(0, 0);
            r.fillStyle(0xFFFFFF, 1);
            r.fillRect(0, 0, game.scale.width, game.scale.height);
            return r;
        }
        
        public showSecondPart():void {
            let r = this.createGraphicsRect();
            this.add(r);
            r.alpha = 0;
            this.scene.tweens.add({
                targets: r,
                alpha: 1,
                duration: 3500,
                onComplete: ()=>{
                    let s = new AnimationStory_6_2(this.scene);
                    this.addAt(s, this.getIndex(r));

                    this.scene.tweens.add({
                        targets: r,
                        alpha: 0,
                        duration: 3500,
                        onComplete: ()=>{                            
                            this.remove(r);
                        }
                    });
                }
            });
            
        }

        public showSpeechDialog(textKey:string):void {
            this._bubblex_mc = new Phaser.GameObjects.Image(this.scene, 240, 140, 'ui-atlas', 'bubblex_mc'+'0000');
            this._bubblex_mc.setOrigin(0.5, 1);
            this.add(this._bubblex_mc);

            this._mouthPiece_mc = new Phaser.GameObjects.Image(this.scene, 240, 130, 'ui-atlas', 'mouthPiece_mc'+'0000');
            this._mouthPiece_mc.setOrigin(0.5, 1);
            this.add(this._mouthPiece_mc);

            this._bubblex_mc.alpha = 0.5;
            this._bubblex_mc.scaleX = 0.75;
            this.scene.tweens.add({
                targets: this._bubblex_mc,
                duration: 500,
                scale:1,
                alpha:1,
                ease:Phaser.Math.Easing.Back.Out
            });
            this._mouthPiece_mc.alpha = 0.5;
            this._mouthPiece_mc.scale = 0.72;
            this.scene.tweens.add({
                targets: this._mouthPiece_mc,
                duration: 500,
                scale:0.72,
                alpha:1,
                ease:Phaser.Math.Easing.Back.Out
            });
            this.add(this._bubblex_mc);

            this._tf = this.scene.add.text(20, 30, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 10,
                "color": "#000000",
                "align": 'left'
            });
            this._tf.setOrigin(0, 0);
            this._tf.setWordWrapWidth(455);
            this.add(this._tf);
            let textTyper:nscs.util.TextTyper = new nscs.util.TextTyper(this.scene, this._tf, null);
            textTyper.typeText(nscs.gameplay.Gameplay.getText(textKey));
        }
    }
}